const toUpper = require('mn-utils/toUpper');


module.exports = (coin) => {
  const parts = toUpper(coin || '').split('_');
  const left = parts[0];
  const right = parts[1];
  return right ? [
    left,
    right,
  ] : [
    left,
    left,
  ];
};
